const reportsMixin = {
  data() {
    return {
      type: null,
      lessonSlug: null,
      orders: null,
      dateFrom: null,
      dateTo: null
    }
  },
  created() {
    this.dateFrom = this.$moment()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.dateTo = new Date().toISOString().substr(0, 10)
  },
  methods: {
    async csvExport() {
      await this.searchItems('csv')

      // const downloadFile = await this.searchItems('csv')

      // const blob = this.createBlob(downloadFile, 'text/csv')

      // const uuid = Math.random()
      //   .toString(36)
      //   .slice(-10)

      // const filename = `${this.type}-report-${uuid}.csv`

      // this.downloadBlob(blob, filename)
    },
    async lessonSelected(lessonSlug) {
      this.lessonSlug = lessonSlug
      // await this.searchItems()
    },
    async orderSelected(list) {
      this.orders = list
      await this.searchItems()
    },
    async dateToSelected(dateTo) {
      this.dateTo = dateTo
      await this.searchItems()
    },
    async dateFromSelected(dateFrom) {
      this.dateFrom = dateFrom
      await this.searchItems()
    },
    async searchItems(output) {
      if (typeof output === 'undefined') output = ''

      let url = `/api/clients/reports?type=${this.type}&date_start=${this.dateFrom}&date_end=${this.dateTo}&output=${output}`
      let new_dateTo = this.$moment(this.dateTo)
        .add('days', 1)
        .format('YYYY-MM-DD')

      if (this.$store.state.isSDECC == 1 && this.type != 'schoolsBySector') {
        url = `/api/clients/reports?type=${this.type}&isSDECC=1&date_start=${this.dateFrom}&date_end=${new_dateTo}&output=${output}`
      }

      if (this.type === 'survey') {
        url = url + `&lessonSlug=${this.lessonSlug}&orders=${this.orders}`
      }

      if (output === 'csv') {
        this.downloadFromUrl(`${window.location.origin}${url}`, '')
      } else {
        let result = await this.$axios.get(url)
        this.items = typeof result === 'object' ? result : { data: [] }
      }
    }
  }
}

export default reportsMixin
